<svelte:window bind:innerWidth={innerWidth} />
<ScrollSuppressor {scrollingElementAccessor} enable={menuOpen}/>

<nav role="navigation" class="mh-desktop" aria-label={desktopAriaLabel ? desktopAriaLabel : "Desktop Header"}>
  <ul>
    {#each items as item}
      {#if item.type === 'link'}
        <NavLink {colorClassNames} {...item.parameters}  />
      {:else if item.type === 'sep'}
        <NavSeparator {colorClassNames} />
      {:else if item.type === 'profile'}
        <ProfileDropdown {colorClassNames} {...item.parameters} {user} />
      {:else if item.type === 'premiumDropdown'}
        <PremiumDropdown {colorClassNames} {...item.parameters} {user} />
      {/if}
    {/each}
  </ul>
</nav>

<div class="mh-mobile-menu">
  {#if user}
    {#if mobileMenu.profileLink}
      <a
        href={mobileMenu.profileLink.href}
        class={colorClassNames.primary}
      >
        <UserIcon {...user} />
      </a>
    {:else}
      <UserIcon {...user} />
    {/if}
  {/if}

  {#if mobileItems.length > 0}
    <BurgerButton
      {menuOpen}
      on:click={() => (menuOpen = !menuOpen)}
      className={colorClassNames.primary} />
  {/if}

  {#if menuOpen}
    <div class="mh-overlay" transition:fade on:click={() => (menuOpen = false)} />

    <nav
      id="mh-mobile-navigation"
      role="navigation"
      aria-label={mobileAriaLabel ? mobileAriaLabel : "Mobile Header"}
      in:fly
      out:fly={{ duration: durations.short, easing: easings.out }}>
      <ul>
        {#each mobileItems as item, index}
          {#if item.type === 'link'}
            <NavLink {colorClassNames} {index} {...item.parameters} />
          {:else if item.type === 'sep'}
            <NavSeparator {colorClassNames} {index} aria-hidden="true" />
          {:else if item.type === 'premiumDropdown'}
            <PremiumDropdownMenu {colorClassNames} {index} {...item.parameters} isMobile={true} />
          {/if}
        {/each}
      </ul>

      <div
        class="mh-brand-wrapper"
        in:fly={{ delayMultiplier: mobileBrandDelayMultiplier }}>
        <Brand className={colorClassNames.primary} {...brand} />
      </div>
    </nav>
  {/if}
</div>

<style lang="less">
      @import (less) '@spotify-internal/encore-foundation/web/tokens.css';

  nav.mh-desktop {
    display: none;
  }

  .mh-mobile-menu {
    display: flex;
    /**
    Needed for IE to not be overlaid by content
     */
    position: relative;

    > a {
      display: inline-flex;
    }

    nav {
      background-color: var(--solid-black-0);
      border-width: 0;
      box-sizing: border-box;
      margin: 0;
      height: 100vh;
      overflow-x: hidden;
      overflow-y: scroll;
      -webkit-overflow-scrolling: touch;
      padding: 38px;
      position: fixed;
      right: 0;
      top: 0;
      width: 447px;
      max-width: 100vw;
      display: flex;
      flex-direction: column;
      justify-content: space-between;
    }

    .mh-brand-wrapper {
      display: inline-block;
      margin-top: 13px;
      width: 89px;
    }

    .mh-overlay {
      display: block;
      width: 100vw;
      height: 100vh;
      position: fixed;
      top: 0px;
      left: 0px;
      background: rgba(0, 0, 0, 0.75);
    }
  }

  ul {
    display: inline;
    list-style: none;
    margin: 0;
    padding: 0;
  }

  @media (min-width: @breakpoint-tablet) {
    nav.mh-desktop {
      display: inline-block;
    }

    .mh-mobile-menu {
      display: none;
    }

    ul {
      display: inline-flex;
    }
  }
</style>

<script>
  import { fade, fly, durations, easings } from '../../../lib/animation';

  import Brand from '../../shared/Brand.html';
  import NavLink from './NavLink.html';
  import NavSeparator from './NavSeparator.html';
  import ProfileDropdown from './ProfileDropdown.html';
  import BurgerButton from './BurgerButton.html';
  import UserIcon from './UserIcon.html';
  import ScrollSuppressor from './ScrollSuppressor.html';
  import PremiumDropdown from './PremiumDropdown.html';
  import PremiumDropdownMenu from './PremiumDropdownMenu.html';


  export let user = null; 
  export let brand;
  export let items = null;
  export let mobileMenu = null;
  export let colorClassNames;
  export let scrollingElementAccessor;
  export let desktopAriaLabel;
  export let mobileAriaLabel;

  let innerWidth;
  let menuOpen = false;

  $: items = items || [];

  $: mobileItems = items.reduce(
    (acc, item) => [
      ...acc,
      ...(item.type === 'profile'
        ? item.parameters.items.map(profileItem => ({
            ...profileItem,
            parameters: { ...profileItem.parameters, tier: 2 },
          }))
        : [item]),
    ],
    [],
  );

  // The mobile Spotify logo gets an extra (5 * base delay) of
  // animation delay because it's pushed to the very bottom
  // of the menu panel.
  $: mobileBrandDelayMultiplier = mobileItems.length + 5;
</script>
